import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {CoinFlightView} from '@gongxigames/framework/slot/modules/buyBonus/coinFlight/CoinFlightView';
import {CoinFlightEvents} from '@gongxigames/framework/slot/modules/buyBonus/coinFlight/CoinFlightEvents';
import {isEnabledRubyCoins} from '@gongxigames/framework/slot/modules/buyBonus/isEnabledRubyCoins';
import {CoreDI, inject, ModuleIsEnabledFilter} from '@gongxigames/framework/core';
import {Module} from '@gongxigames/framework/slot/fragments/module/Module';
import {GameConfig} from '@gongxigames/framework/slot/types';
import {ReelConstants} from '@gongxigames/framework/slot/utils';

export class CoinFlightModule extends Module<CoinFlightView> {
    public static readonly NAME: symbol = Symbol('CoinFlightModule');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledRubyCoins;

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    protected setupViews(): void {
        this.setView(CoinFlightView.NAME);
    }

    protected setupStates(): void {
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.on(FlowModuleEvents.START_COIN_FLIGHT_FEATURE, this.startCoinFlight);

        this.onView(CoinFlightView.FLIGHT_FINISHED, this.onFlightFinished);
    }

    protected startCoinFlight(): void {
        const logic = this.logic;
        const symbolIds = logic.spinData.symbolIds;
        const rubySymbolIndex = this._gameConfig.reelsConfig.rubySymbol!;
        const rowIndex = symbolIds[ReelConstants.REELS_AMOUNT - 1].indexOf(rubySymbolIndex);

        this.view.startFlightAnimation(rowIndex, logic.getRubyBalance());
        this.view.playFlightSound();
        this.eventManager.emit(CoinFlightEvents.COIN_FLIGHT_STARTED, rowIndex);
    }

    protected onFlightFinished(eventID: symbol, balance: number): void {
        this.eventManager.emit(CoinFlightEvents.COIN_FLIGHT_FINISHED, balance);
    }
}
